/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLazyQuery, useSubscription } from "@apollo/client";
import { useSnackbar as Snackbar } from "notistack";
import TotalChatImg from "src/assets/images/dashboard/totalChatsIcon.png";
import { UseDashboardContext } from "src/context/dashboard";
import GETUSERTOTALCHATCOUNT from "src/graphql/query/dashboard/FigureCards/getUserTotalChatCount";
import TOTALCHATCOUNTSUBSCRIPTION from "src/graphql/subscriptions/dashboard/totalChatCountChanged";
import { safeJsonParse } from "src/utils/shared/safeJson";
import GeneralCard from "../GeneralCard";

const TotalChats = () => {
  const { enqueueSnackbar } = Snackbar();
  const contextData = UseDashboardContext();

  let totalChats: number = 0;
  let setTotalChats: (a: number) => void;
  let storedAgentId: number = 0;
  let globalTimeFrame: string = "today";

  if (contextData) {
    ({ totalChats, setTotalChats, storedAgentId, globalTimeFrame } =
      contextData);
  }
  const [
    getTotalChats,
    {
      data: getUserTotalChatCountsData,
      loading: getUserTotalChatCountsLoading,
    },
  ] = useLazyQuery(GETUSERTOTALCHATCOUNT, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (storedAgentId) {
      getTotalChats({
        variables: {
          agentId: [storedAgentId],
          timeFrame: globalTimeFrame,
        },
      });
    }
  }, [storedAgentId, globalTimeFrame]);

  useEffect(() => {
    if (
      getUserTotalChatCountsData &&
      getUserTotalChatCountsData.getUserTotalChatCount
    ) {
      if (getUserTotalChatCountsData.getUserTotalChatCount.success) {
        setTotalChats(getUserTotalChatCountsData.getUserTotalChatCount.count);
      } else {
        enqueueSnackbar(
          getUserTotalChatCountsData.getUserTotalChatCount.error,
          {
            variant: "error",
          },
        );
      }
    }
  }, [getUserTotalChatCountsData]);

  //
  const {
    data: totalchatcountchangedSubscriptionResult,
    error: totalchatcountchangedSubscriptionError,
  } = useSubscription(TOTALCHATCOUNTSUBSCRIPTION);

  useEffect(() => {
    if (totalchatcountchangedSubscriptionError) {
      enqueueSnackbar(totalchatcountchangedSubscriptionError.message, {
        variant: "error",
      });
    }
  }, [totalchatcountchangedSubscriptionError]);

  useEffect(() => {
    if (
      totalchatcountchangedSubscriptionResult &&
      globalTimeFrame === "today"
    ) {
      const { count, agentId } = safeJsonParse<any>(
        totalchatcountchangedSubscriptionResult.totalchatcountchanged.result,
        { count: 0, agentId: null },
        "Total Chats",
      );
      if (storedAgentId === Number(agentId)) setTotalChats(count);
    }
  }, [totalchatcountchangedSubscriptionResult]);

  return (
    <GeneralCard
      tourId="tour-dashboard-total-card"
      cardImage={TotalChatImg}
      count={totalChats}
      loader={getUserTotalChatCountsLoading}
      dropDownValues={globalTimeFrame}
      hideDropdown
      title="Total Chats"
    />
  );
};

export default TotalChats;
